export default __webpack_public_path__ + "static/media/info_modal.25ab50b5.png";